import DOMPurify from "dompurify"

/**
 * Rich text written by staff (product descriptions, later pages and emails) is
 * shown to other staff, including the owner. Sanitise before rendering so a
 * staff member with only "products" access can't plant a script that runs as
 * someone with more access.
 */
export function safeHtml(html: string | null | undefined): string {
  if (!html) return ""
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ["style", "form", "input", "button", "iframe", "object", "embed"],
    FORBID_ATTR: ["style"],
  })
}
